"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useQuantityPicker = useQuantityPicker;
var _react = require("react");
var QuantityPickerClick = _interopRequireWildcard(require("./QuantityPickerClickEvent"));
var _useControlledQuantityPicker = require("./useControlledQuantityPicker");
var _useDebug = require("./useDebug");
var _useUncontrolledQuantityPicker = require("./useUncontrolledQuantityPicker");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
/**
 * Use QuantityPicker - logic for QuantityPicker with increase and decrease events
 * Can be uses with controlled or uncontrolled manner
 * @param {UseQuantityPickerProps} props
 */ function useQuantityPicker(props) {
    var autoId = (0, _react.useId)();
    var _props_id = props.id, id = _props_id === void 0 ? autoId : _props_id, InputProps = props.InputProps, value = props.value, _props_visibilityTriggerClicked = props.visibilityTriggerClicked, visibilityTriggerClicked = _props_visibilityTriggerClicked === void 0 ? false : _props_visibilityTriggerClicked;
    var _ref = _sliced_to_array((0, _react.useState)(''), 2), lastIncreased = _ref[0], setLastIncreased = _ref[1];
    var _ref1 = _sliced_to_array((0, _react.useState)(visibilityTriggerClicked), 2), loadOnClick = _ref1[0], setLoadOnClick = _ref1[1];
    var log = (0, _useDebug.useDebug)("ID-".concat(id)).log;
    var triggerClickEvent = (0, _react.useCallback)(function(identifier) {
        var event = new CustomEvent(QuantityPickerClick.Name, {
            detail: {
                id: identifier
            }
        });
        window.dispatchEvent(event);
    }, []);
    /** Called on clickAway to reset lastIncreased when clicking on other lickers and/or other links */ var resetLastIncreased = (0, _react.useCallback)(function(source) {
        log(source, 'reset tooltip triggers');
        setLastIncreased('');
        setLoadOnClick(false);
    }, [
        log
    ]);
    var handleKeyDown = (0, _react.useCallback)(function(param) {
        var currentTarget = param.currentTarget, key = param.key;
        if (key === 'Enter') {
            currentTarget.blur();
        }
    }, []);
    /** Set last increased for newly initiated.
   * In case that the value is set to zero, on next increase will be set as newly initiated again.
   */ (0, _react.useEffect)(function() {
        if (loadOnClick && typeof value === 'number' && value === 1) {
            setLastIncreased(id);
        }
        triggerClickEvent(id);
        setLoadOnClick(false);
    }, [
        id,
        loadOnClick,
        triggerClickEvent,
        value
    ]);
    var onQuantityPickerClickListener = function(event) {
        if (event.detail.id !== id) {
            resetLastIncreased("action on ".concat(event.detail.id, " ➡️"));
        }
    };
    (0, _react.useEffect)(function() {
        window.addEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
        return function() {
            window.removeEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
        };
    });
    var innerProps = _object_spread_props(_object_spread({}, props), {
        id: id,
        loadOnClick: loadOnClick,
        log: log,
        setLastIncreased: setLastIncreased,
        triggerClickEvent: triggerClickEvent
    });
    var _ref2 = (0, _react.useRef)(value != null), isControlled = _ref2.current;
    var controlled = (0, _useControlledQuantityPicker.useControlledQuantityPicker)(innerProps);
    var uncontrolled = (0, _useUncontrolledQuantityPicker.useUncontrolledQuantityPicker)(innerProps);
    var logBase = (0, _react.useMemo)(function() {
        var increase = lastIncreased === id ? '🟢LAST INCREASED' : '🟡';
        var opened = visibilityTriggerClicked && loadOnClick ? '🆕 LAST OPENED' : '';
        return [
            increase,
            opened
        ];
    }, [
        id,
        lastIncreased,
        loadOnClick,
        visibilityTriggerClicked
    ]);
    if (isControlled) {
        return _object_spread_props(_object_spread({}, controlled), {
            InputProps: _object_spread({}, InputProps),
            lastIncreased: lastIncreased,
            handleKeyDown: handleKeyDown,
            logBase: logBase
        });
    }
    return _object_spread_props(_object_spread({}, uncontrolled), {
        InputProps: _object_spread({}, InputProps),
        lastIncreased: lastIncreased,
        handleKeyDown: handleKeyDown,
        logBase: logBase
    });
} //# sourceMappingURL=useQuantityPicker.js.map
